import { BaseElectionPost } from "./base/BaseElectionPost";
import { convertirFecha, formatProvinciaLocalidad } from "../utils/dataFormatter";

export class LegislativasPost extends BaseElectionPost {
  constructor() {
    super({
      electionType: 'legislativas',
      thresholds: { low: 1, medium: 50, high: 100 } // A1 hasta 1%, luego A2
    });
  }

  /**
   * ALTERNATIVA 0 y 1: Sin datos o menos del 1% (antes de comenzar)
   */
  createInitialContent(data, params) {
    const fechasFormateadas = convertirFecha(data.last_update);
    const formatedProvinciaLocalidad = formatProvinciaLocalidad(data.provinciaLocalidad);

    return {
      title: `Resultados Elecciones 2025 en la ${formatedProvinciaLocalidad}: a qué hora se conocerán los primeros datos oficiales de CABA`,
      summary: `
        <ul>
          <li>Los vecinos de la Ciudad de Buenos Aires eligen legisladores este domingo 18 de mayo.</li>
          <li>El escrutinio minuto a minuto, el mapa por Comuna y todo lo que tenés que saber.</li>
        </ul>`,
      subtitle: "",
      description: "",
      gtmPublishedDate: "2025-05-18T",
      publishedDate: "2025-05-18T14:00:17-03:00",
      formattedPublishedDate: "18 MAY 2025",
      lastModified: "2025-05-18T14:00:16-03:00",
      modificatedAt: "2025-05-18T14:00:00Z",
      keywords: "",
      source: 1,
      createdAt: "2025-05-18T20:32:57.407Z",
      body: [
        {
          type: "text",
          value: `<p>Los vecinos de la <strong>${formatedProvinciaLocalidad}</strong> acudieron a las urnas este domingo 18 de mayo para 
            participar en las <strong>elecciones legislativas CABA 2025,</strong> a partir de la cual se renovarán 30 de las 60 bancas que componen la <strong>Legislatura 
            porteña,</strong> correspondientes a los legisladores cuyos mandatos comenzaron en el 2021 y concluyen este año.</p>`
        },
        {
          type: "text",
          value: `<p>Hay gran expectativa por los <strong>resultados oficiales</strong> en esta ${formatedProvinciaLocalidad} y en la <strong>Ciudad de Buenos Aires 
            en general</strong>, los cuales comenzarán a difundirse pasadas las 18 horas.</p>`
        },
        {
          type: "text",
          value: `<p>Los <strong>legisladores electos</strong> asumirán sus funciones el 10 de diciembre y desempeñarán un mandato de cuatro años.</p>`
        },
        {
          type: "text",
          value: `<p>La Legislatura de la Ciudad es el órgano encargado de sancionar leyes que regulan aspectos fundamentales de la vida urbana, 
            tales como educación, salud, seguridad, transporte y planificación urbana en territorio porteño.</p>`
        },
        {
          type: "text",
          value: `<p>En la Ciudad de Buenos Aires, más de 2,5 millones de personas figuran en el <strong>padrón electoral</strong>. 
            La obligación de votar alcanza a todos los ciudadanos argentinos, naturalizados y a los extranjeros con residencia permanente, 
            siempre que sean mayores de 16 años y tengan DNI con domicilio en la Ciudad.</p>`
        },
        {
          type: "text",
          value: `<p>Seguí toda la información del <strong>escrutinio</strong> de las Elecciones CABA 2025 y todo lo que tenés que saber, minuto a minuto.</p>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/encabezan-listas-partido-elecciones-2025-caba_0_o47zwnA6hG.html" target="_blank">
            Elecciones 2025 en CABA: uno por uno, los candidatos de cada partido</a></h2>`
        },
        {
          type: "text",
          value: `<ul>
            <li><strong>Buenos Aires Primero:</strong> Silvia Lospennato, Hernán Lombardi y Laura Alonso</li>
            <li><strong>Es Ahora Buenos Aires:</strong> Leandro Santoro, Claudia Negri y Federico Mochi</li>
            <li><strong>La Libertad Avanza:</strong> Manuel Adorni, Solana Pelayo y Nicolás Pakgojz</li>
            <li><strong>FITU:</strong> Vanina Biasi, Luca Bonfante y Celeste Fierro</li>
            <li><strong>Volvamos Buenos Aires:</strong> Horacio Rodríguez Larreta, Guadalupe Tagliaferri y Emmanuel Ferrario</li>
            <li><strong>Ucedé:</strong> Ramiro Marra, Nabila Michitte y Eduardo Del Piano</li>
            <li><strong>Evolución:</strong> Lucille Levy, Facundo Cedeira y Jésica Barreto</li>
            <li><strong>Coalición Cívica:</strong> Paula Oliveto, Fernando Sánchez y María Pace Wells</li>
            <li><strong>Unión Porteña Libertaria:</strong> Yamil Santoro, María Alejandra Muchart y Leandro Campelo</li>
            <li><strong>Principios y valores:</strong> Alejandro Kim, Nydia Lirola y Raúl Vázquez</li>
            <li><strong>Seamos Libres:</strong> J. M. Abal Medina, Carolina Papaleo y Pablo Bercovich</li>
            <li><strong>MID:</strong> R. Caruso Lombardi, Sandra Saravia y Miguel Ángel Arancio</li>
            <li><strong>Confluencia:</strong> María Eva Koutsovitis, Ariel Elger y Mónica Ruejas</li>
            <li><strong>Nuevo Más:</strong> Federico Winokur, Violeta Azriel Alonso y Alejandro Leiva</li>
            <li><strong>Frente Patriota Federal:</strong> César Biondini, Verónica Cardozo y Héctor Jaime</li>
            <li><strong>Remedios para CABA:</strong> Marcelo Peretta, Valentina Peretta Alejandre y Federico González</li>
            <li><strong>El Movimiento - Nueva Generación:</strong> Mila Zurbriggen, Lucas Arias y Julieta Goldsman</li>
          </ul>`
        },
        {
          type: "text",
          value: `<h2><a href="https://www.clarin.com/informacion-general/multa-votar-multa-votar-elecciones-2025-caba_0_6sSTsOlQEJ.html" target="_blank">
            Elecciones CABA 2025: qué pasa si no voté en la ${formatedProvinciaLocalidad}</a></h2>`
        },
        {
          type: "text",
          value: `<p>En la Ciudad de Buenos Aires el voto es obligatorio para los ciudadanos argentinos residentes mayores de 18 y menores de 70 años. 
            Aquellos mayores de 16 que no lleguen a 18 y los más de 70 años pueden votar, pero no tienen la obligación de hacerlo. 
            Es decir que los primeros, si no votan y no justifican el faltazo, pueden recibir una multa económica, 
            pero también algunas restricciones para realizar ciertos trámites ante organismos públicos.</p>`
        },
        {
          type: "text",
          value: `<h2>Boca de urna en la ${formatedProvinciaLocalidad}: qué es y cómo funciona</h2>`
        },
        {
          type: "text",
          value: `<p><strong>"Boca de urna"</strong> es uno de los términos más buscados tanto en redes sociales como en Google a la hora de anticiparse a los <strong>resultados oficiales</strong>. 
            Se trata de encuestas que se realizan a la salida de los establecimientos electorales luego de que los votantes emitieron su sufragio. 
            Los medios de comunicación no pueden publicar estas cifras por ley, pues está prohibido cualquier tipo de difusión masiva de datos extraoficiales.</p>`
        },
        {
          type: "text",
          value: `<h2>Resultados Elecciones 2025: qué son las mesas testigo</h2>`
        },
        {
          type: "text",
          value: `<p>Las <strong>mesas testigo</strong> son elegidas por los partidos políticos para tener una proyección propia sobre los resultados de las elecciones. 
            Los cómputos son suministrados por los fiscales de mesa y dan una idea aproximada de cómo avanza el escrutinio a nivel general.</p>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * ALTERNATIVA 2 y 3: Con datos (más del 1% escrutado)
   */
  createEarlyContent(data, params) {
    return this.createResultsContent(data, params);
  }

  createPartialContent(data, params) {
    return this.createResultsContent(data, params);
  }

  createFinalContent(data, params) {
    return this.createResultsContent(data, params);
  }

  /**
   * Contenido con resultados
   */
  createResultsContent(data, params) {
    const firstPlace = data.candidatos[0];
    const firstCandidate = firstPlace.candidates[0]?.fullname || 'Sin nombre';
    const firstParty = firstPlace.name;
    const firstPercentage = firstPlace.candidates[0]?.votes_percent_2?.toFixed(2) || firstPlace.votes_percent?.toFixed(2);
    
    const secondPlace = data.candidatos[1];
    const secondCandidate = secondPlace.candidates[0]?.fullname || 'Sin nombre';
    const secondParty = secondPlace.name;
    const secondPercentage = secondPlace.candidates[0]?.votes_percent_2?.toFixed(2) || secondPlace.votes_percent?.toFixed(2);
    
    const thirdPlace = data.candidatos[2];
    const thirdCandidate = thirdPlace.candidates[0]?.fullname || 'Sin nombre';
    const thirdParty = thirdPlace.name;
    const thirdPercentage = thirdPlace.candidates[0]?.votes_percent_2?.toFixed(2) || thirdPlace.votes_percent?.toFixed(2);

    const formatedProvinciaLocalidad = formatProvinciaLocalidad(data.provinciaLocalidad);
    const barrios = data.barrios?.join(', ') || '';
    const mesas = data.mesasEscrutadas?.toFixed(2) || '0.00';
    const comuna = data.localidad;
    const last_update = data.last_update;
    
    // Armar lista de candidatos
    const candidatosLista = data.candidatos.map(c => {
      const nombre = c.candidates[0]?.fullname || 'Sin nombre';
      const porcentaje = c.votes_percent?.toFixed(2) || '0.00';
      return `<li>${nombre} (${porcentaje}%)</li>`;
    }).join('\n');
    
    const resultadosHtml = `
      <p>Con el ${mesas}% de las mesas escrutadas, estos son los resultados en la ${comuna}:</p>
      <ul>
        ${candidatosLista}
      </ul>
    `;

    return {
      title: `Resultados Elecciones CABA 2025: quién ganó en la ${formatedProvinciaLocalidad}`,
      summary: `
        <ul>
          <li>Los vecinos de la Ciudad de Buenos Aires eligen legisladores este domingo 18 de mayo.</li>
          <li>El escrutinio minuto a minuto, el mapa por Comuna y todo lo que tenés que saber.</li>
        </ul>`,
      subtitle: "",
      description: "",
      gtmPublishedDate: "2025-05-18T",
      publishedDate: "2025-05-18T14:00:17-03:00",
      formattedPublishedDate: "18 MAY 2025",
      lastModified: "2025-05-18T14:00:16-03:00",
      modificatedAt: last_update,
      keywords: "",
      source: 1,
      createdAt: "2025-05-18T20:32:57.407Z",
      body: [
        {
          type: "text",
          value: `<p>Los vecinos de la <strong>${formatedProvinciaLocalidad}</strong> acudieron a las urnas este domingo 18 de mayo para participar en las <strong>elecciones 
            legislativas CABA 2025</strong>, a partir de la cual se renovarán 30 de las 60 bancas que componen la Legislatura porteña, 
            correspondientes a los legisladores cuyos mandatos comenzaron en 2021 y concluyen este año.</p>`
        },
        {
          type: "text",
          value: `<p>En esta Comuna, integrada por ${barrios}, en primer lugar se ubica 
            <strong>${firstCandidate}</strong> (${firstParty}), con el ${firstPercentage}% de los sufragios, en tanto que en segunda posición se encuentra 
            <strong>${secondCandidate}</strong> (${secondParty}), con el ${secondPercentage}%, y le sigue <strong>${thirdCandidate}</strong> (${thirdParty}), con el ${thirdPercentage}%.</p>`
        },
        {
          type: "text",
          value: `<h2>Elecciones CABA 2025: resultados en la ${comuna}</h2>`
        },
        {
          type: "text",
          value: resultadosHtml
        },
        {
          type: "text",
          value: `<h2>Resultados de las Elecciones 2025 en CABA</h2>`
        },
        {
          type: "text",
          value: `<p>A nivel general en la Ciudad de Buenos Aires, <strong>${data.ganador?.candidates[0]?.fullname || 'Sin nombre'}</strong> (${data.ganador?.name}) logra el primer lugar con el ${data.ganador?.votes_percent?.toFixed(2)}% de los votos. 
            Le siguen <strong>${data.segundo?.candidates[0]?.fullname || 'Sin nombre'}</strong> (${data.segundo?.name}) y <strong>${data.tercero?.candidates[0]?.fullname || 'Sin nombre'}</strong> (${data.tercero?.name}).</p>`
        },
        {
          type: "text",
          value: `<h2>Elecciones 2025: cuándo asumen los nuevos legisladores en CABA</h2>`
        },
        {
          type: "text",
          value: `<p>Los legisladores electos asumirán sus funciones el <strong>10 de diciembre</strong> y desempeñarán un mandato de cuatro años. 
            La Legislatura de la Ciudad es el órgano encargado de sancionar leyes que regulan aspectos fundamentales de la vida urbana, 
            tales como educación, salud, seguridad, transporte y planificación urbana en territorio porteño.</p>`
        },
        {
          type: "text",
          value: `<p>Entre las fuerzas políticas que compitieron en estos comicios se encuentran el PRO, que pone en juego 15 bancas; 
            la alianza Es Ahora Buenos Aires, con 8; y La Libertad Avanza, con 6.</p>`
        },
        {
          type: "text",
          value: `<p>La distribución de cargos se realiza con el método D´Hondt, denominado así por el jurista y matemático Victor D'Hondt.</p>`
        },
        {
          type: "text",
          value: `<p>Se trata de una fórmula electoral que permite hacer una distribución de bancas proporcional a los votos obtenidos por cada 
            agrupación política (partido o alianza), siempre y cuando la fuerza haya obtenido un piso de 3% de los votos válidos.</p>`
        }
      ],
      authors: [],
      sections: this.getSections(),
      metadata: this.getMetadata()
    };
  }

  /**
   * Helpers
   */
  getSections() {
    return [
      {
        _id: 15006,
        name: "Información General",
        url: "informacion-general",
        nsSite: "",
        autoplay: false,
        metadata: {}
      }
    ];
  }

  getMetadata() {
    return {
      typeWeb: "small",
      origin: "default",
      payWallAccessControl: "freemium",
      sponsored: false,
      accessProduct: "CLARIN_D",
      canHaveAmp: true,
      canHaveComments: true,
      autoRefresh: true,
      titleEnable: false,
      footer_visible: true,
      ualterDisabled: false,
      trinityDisabled: false,
      disabledTimelineLiveblog: false,
      featuredContent: false,
      stopWords: true
    };
  }

  getTags(params) {
    return [
      { name: "Elecciones 2025", slug: "elecciones-2025", subject: "subject", _id: "4JzQK5otxx" },
      { name: "Ciudad de Buenos Aires", slug: "ciudad-de-buenos-aires", subject: "subject", _id: "EJcOBdLDg" },
      { name: "Legislativas", slug: "legislativas", subject: "subject" }
    ];
  }

  generateMeta(content, data, params) {
    const title = content?.title || `Elecciones Legislativas ${params.year || 2025} - CABA`;
    const description = this.extractDescription(content) || 
                       `Resultados elecciones legislativas en Ciudad de Buenos Aires`;
    const imageUrl = this.getImage(params.codeLetter);

    return {
      description,
      title,
      keywords: `Legislativas, CABA, Ciudad de Buenos Aires, Elecciones ${params.year || 2025}, Resultados, Legislatura porteña`,
      url: params.baseUrl,
      urlImage: imageUrl,
      extra: [
        { name: "title", content: title },
        { name: "description", content: description },
        { name: "distribution", content: "global" },
        { name: "robots", content: "max-image-preview:large" },
        { property: "og:image", content: imageUrl },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "article:published_time", content: `${params.year || 2025}-05-18T14:00:17-03:00` },
        { property: "article:modified_time", content: data.last_update }
      ]
    };
  }

  extractDescription(content) {
    return content?.description || 
           content?.body?.[0]?.value?.replace(/<[^>]*>/g, '')?.trim();
  }
}